
import { defineComponent, computed } from "vue";
import { Measurement } from "@gamma/types.data";

export default defineComponent({
  name: "MeasurementSelection",
  props: {
    value: {
      type: Object as () => Measurement,
      required: false,
    },
  },
  emits: ["input"],
  setup(props, { emit }) {
    const measurementOptions = [
      {
        value: "",
        name: "-- None --",
      },
      {
        value: "Distance",
        name: "Distance",
      },
      {
        value: "Currency",
        name: "Currency",
      },
    ];

    const measurementType = computed({
      get(): string {
        return props.value?.measurementType || "";
      },
      set(val: string) {
        emit(
          "input",
          val !== ""
            ? ({
                ...props.value,
                measurementType: val,
              } as Measurement)
            : undefined
        );
      },
    });

    const units = computed({
      get(): string {
        return props.value?.measurementUnit || "";
      },
      set(val: string) {
        emit("input", {
          ...props.value,
          measurementUnit: val,
        } as Measurement);
      },
    });

    return {
      measurementType,
      units,
      measurementOptions,
    };
  },
});
